import { useRef } from 'react'

// Allows a function 'fn' to be delayed by a set timeframe 'ms'
// If this is called again before the time 'ms' elapses, the timer resets

const useDebounce = (fn, ms) => {
  const timeOutId = useRef()
  const onChange = (...params) => {
    if (timeOutId.current) {
      clearTimeout(timeOutId.current)
    }
    timeOutId.current = setTimeout(fn, ms, ...params)
  }
  return onChange
}

export default useDebounce
